import { render } from "./TopDriversBarChart.vue?vue&type=template&id=52d1ea49&scoped=true"
import script from "./TopDriversBarChart.vue?vue&type=script&lang=js"
export * from "./TopDriversBarChart.vue?vue&type=script&lang=js"

import "./TopDriversBarChart.vue?vue&type=style&index=0&id=52d1ea49&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d1ea49"]])

export default __exports__